import { NavLink } from 'react-router-dom';
import { Home, Radio, Calendar, Trophy, Users } from 'lucide-react';
import { PUBLIC_ROUTES } from '@/constants';
import { cn } from '@/lib/utils';

const MOBILE_NAV = [
  { label: 'Home', to: PUBLIC_ROUTES.HOME, icon: Home, end: true },
  { label: 'Live', to: PUBLIC_ROUTES.LIVE, icon: Radio },
  { label: 'Fixtures', to: PUBLIC_ROUTES.FIXTURES, icon: Calendar },
  { label: 'Tournaments', to: PUBLIC_ROUTES.TOURNAMENTS, icon: Trophy },
  { label: 'Teams', to: PUBLIC_ROUTES.TEAMS, icon: Users },
];

function PublicMobileNav() {
  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 border-t border-border bg-card/95 backdrop-blur-xl pb-[env(safe-area-inset-bottom)] md:hidden"
      aria-label="Mobile bottom navigation"
    >
      <ul className="flex items-stretch justify-around">
        {MOBILE_NAV.map(({ label, to, icon: Icon, end }) => (
          <li key={to} className="flex-1">
            <NavLink
              to={to}
              end={end}
              className={({ isActive }) =>
                cn(
                  'flex min-h-[56px] flex-col items-center justify-center gap-0.5 px-1 py-2 text-[10px] font-semibold transition-colors',
                  isActive ? 'text-primary' : 'text-muted-foreground'
                )
              }
            >
              <Icon className="h-5 w-5" aria-hidden="true" />
              <span>{label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}

export default PublicMobileNav;
